import styled from 'styled-components';

const PricingSection = styled.div`
  background-color: var(--color-bg-weakest2);
  border: 1px solid var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  padding: 24px;
`;

export { PricingSection };
